/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChangeDecisionForProjectPenaltyCommand } from '../../models/change-decision-for-project-penalty-command';
import { ChangeDecisionForProjectPenaltyCommandResult } from '../../models/change-decision-for-project-penalty-command-result';

export interface ApiProjectPenaltiesChangeDecisionForProjectPenaltyPost$Params {
      body?: ChangeDecisionForProjectPenaltyCommand
}

export function apiProjectPenaltiesChangeDecisionForProjectPenaltyPost(http: HttpClient, rootUrl: string, params?: ApiProjectPenaltiesChangeDecisionForProjectPenaltyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ChangeDecisionForProjectPenaltyCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectPenaltiesChangeDecisionForProjectPenaltyPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChangeDecisionForProjectPenaltyCommandResult>;
    })
  );
}

apiProjectPenaltiesChangeDecisionForProjectPenaltyPost.PATH = '/api/ProjectPenalties/ChangeDecisionForProjectPenalty';
